/* eslint-disable zillow/@typescript-eslint/naming-convention */
import type { ABResult } from '@zillow/ab-client';
import abClient, { buildEndpoint } from '@zillow/ab-client';

import type { URLParams } from '../types/genericTypes';

const HOPS_ABS = ['HOPS_ZHL_BANNER', 'SXP_NATURAL_LANGUAGE_SEARCH'];

export const DEFAULT_ABS = {
    SXP_NATURAL_LANGUAGE_SEARCH: {
        treatment: 'CONTROL',
    },
};

export const ABS_TIMEOUT = 1000;
/**
 * Call abService to retrieve trials
 * @param {String} guid
 * @param {Object} abServiceConfig
 * @param {String} abServiceConfig.protocol
 * @param {String} abServiceConfig.host
 * @param {Number} abServiceConfig.port
 * @param {Array} abTrials specific ab Trials to retrieve
 * @param {boolean} mobile true if serving mobile web. false if desktop web
 */
export const getAbs = async (
    guid: string,
    { protocol, host, port }: URLParams,
    abTrials: string[] = [],
    mobile: boolean
): Promise<ABResult> => {
    const forwarded_client_id = mobile ? 'mobile' : 'desktop';
    const headers = {
        client_id: 'homepage-service',
        forwarded_client_id,
    };

    const client = abClient(guid, buildEndpoint(protocol, host, port), ABS_TIMEOUT, null, headers);
    const trials = await client.getTrials(abTrials);
    return trials;
};

/**
 * Retrieve HoPS specific AB's based on the array. If array is empty don't make the ab call
 * @param {String} guid
 * @param {Object} endpointConfig see docblock of getAbs
 * @param {boolean} mobile true if serving mobile web. false if desktop web
 * @returns {Object}
 */
export const getHomepageSpecificAbs = async (
    guid: string,
    endpointConfig: URLParams,
    mobile: boolean
): Promise<ABResult> => {
    if (HOPS_ABS.length > 0) {
        return getAbs(guid, endpointConfig, HOPS_ABS, mobile);
    }
    return {};
};

/**
 * Checks if a given treatment is set for a given trial.
 * @param {object}  obj
 * @param {object}  obj.abs         object containing ab configuration
 * @param {string}  obj.trial       the name of the trial being tested
 * @param {string}  obj.treatment   the name of the treatment
 */
export const isTreatmentForTrial = ({
    abs = {},
    trial = '',
    treatment = null,
}: {
    abs?: ABResult;
    trial?: string;
    treatment?: string | null;
}) => Boolean(treatment && abs[trial]?.treatment === treatment);
